/**
 * Чистые операции над объектом переменных.
 *
 * Большинство переменных хранятся как массив значений по фразам диалога
 * (индекс = номер фразы). Часть переменных — скаляры (см. NON_ARRAY_VARIABLES).
 */
import { NON_ARRAY_VARIABLES } from '../config/appConfig';

const withLength = (value, index) => {
  const arr = Array.isArray(value) ? [...value] : [];
  while (arr.length <= index) {
    arr.push(undefined);
  }
  return arr;
};

/**
 * Вернуть НОВЫЙ объект переменных с установленным значением.
 * Для скалярных переменных пишет значение как есть; для остальных — в массив
 * по индексу фразы (по умолчанию — currentPhraseIndex).
 */
export const setVariableValue = (variables, name, value, phraseIndex = null) => {
  if (NON_ARRAY_VARIABLES.includes(name)) {
    return { ...variables, [name]: value };
  }

  const index =
    phraseIndex !== null && phraseIndex !== undefined
      ? phraseIndex
      : variables.currentPhraseIndex || 0;

  const arr = withLength(variables[name], index);
  arr[index] = value;
  return { ...variables, [name]: arr };
};

/**
 * Скалярное значение переменной для конкретной фразы
 * (массив → элемент по индексу, иначе — само значение).
 */
export const getScalarValue = (variables, name, phraseIndex) => {
  const value = variables[name];
  return Array.isArray(value) ? value[phraseIndex] : value;
};
